import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HospitalAddOnService } from '../services/hospital-add-on.service';

export const pharmacyFeatureGuard: CanActivateFn = () => {
  const addOns = inject(HospitalAddOnService);
  const router = inject(Router);

  if (addOns.isPharmacyEnabled) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};
